import { render } from "./UserCreate.html?vue&type=template&id=32035090&ts=true"
import script from "./UserCreate.ts?vue&type=script&lang=ts"
export * from "./UserCreate.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__